export default (function (height) {
  return "\n    position: absolute;\n    left: 30%;\n    top: 0%;\n    display: inline-block;\n    transform: rotate(45deg);\n    height: ".concat(height, "px;\n    width: ").concat(height / 2, "px;\n");
});